import postAPI from './postAPI.js'

export default async function postSendStepSigning(body) {
    const data = await postAPI('taskinstances/steps/signing/send', body);
    return data;
}
